import createTypes from 'redux-create-action-types';

export default createTypes(
  'SYNC_UPDATE_CHECKLISTS',
  'GET_CHECKLISTS',
  'CREATE_UPDATE_CHECKLIST',
  'CHECK_UNCHECK_CHECKLIST',
  'DELETE_CHECKLIST'
);
